module.exports = __webpack_public_path__ + "img/horizontal_4_4_pp12_1.81b4a79e.png";